(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["westmoor-personalization"] && !Shopify.designMode) return;
  try {
    document.addEventListener("input", (event) => {
  if (!(event.target instanceof HTMLInputElement)) return;
  const fieldset = event.target.closest(".westmoor-lettering");
  if (!fieldset || event.target.type !== "text") return;
  const confirmation = fieldset.querySelector("input[type=checkbox]");
  if (confirmation) confirmation.checked = false;
});
  } catch(e) { console.error(e); }
})();

})();
